import '@splidejs/vue-splide/css/core'
import {defineNuxtPlugin} from '#app'
import VueSplide, {SplideTrack} from '@splidejs/vue-splide'

export default defineNuxtPlugin(async (nuxtApp) => {
  const {vueApp} = nuxtApp
  vueApp.use(VueSplide)
  vueApp.component('SplideTrack', SplideTrack)
})

